"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderSpecContent = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _services = require("../../services");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _brandHifiIcons = require("@vfuk/brand-hifi-icons");
var _useConfig = _interopRequireDefault(require("../../hooks/useConfig"));
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _uiSelectors = require("../../store/ui/uiSelectors");
var _CustomIconOrImage = _interopRequireDefault(require("../shared/CustomIconOrImage"));
var _utils = require("../../utils/utils");
var _useAppSelector = require("../../hooks/useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const VerticalExpandingWrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const DataEntryWrapper = _styledComponents.default.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
`;
const DataEntryWrapperItem = _styledComponents.default.div`
  flex: 1;
  display: flex;
`;
const LightContainer = (0, _styledComponents.default)((0, _BaseComponents.LightBackground)('div'))`
  text-align: center;
  flex: 1;
`;
const ExpandingWrapper = _styledComponents.default.div`
  flex: 1;
`;
const TextDataContainer = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
const StyledGridRow = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  min-height: 70px;
  &:nth-child(odd) {
    background-color: #f4f4f4;
  }
`;
const StyledGridColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  min-height: 0;
  &:not(:last-child) {
    border-right: ${props => props.shouldAddTableBorders && '1px solid #bebebe;'};
  }
`;
const StyledGridColumnContent = (0, _styledComponents.default)(StyledGridColumn)`
  padding: 0;
  word-break: break-word;
`;
const StyledGridColumnWrapper = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  padding: 0;
  text-align: center;
`;
const StyledSpecGridRow = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  align-items: center;
  justify-content: center;
  width: 70%;
`;
const GroupSpecsWrapper = _styledComponents.default.div`
  border-top: ${props => !props.removeBorder && '1px solid #bebebe;'};
  border-bottom: ${props => !props.removeBorder && '1px solid #bebebe;'};
`;
const StyledTooltip = _styledComponents.default.div`
  & span[role='button']:focus,
  & span[role='button']:focus-visible,
  & span[role='button']:focus-within {
    box-shadow: none;
  }
`;
const ColorSwatchContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

//---------------------------------
const handleBooleanValue = value => {
  const applyThemeColorToTickIcon = (0, _useLocalTheme.default)('pages.COMPARISON.applyThemeColorToTickIcon');
  const state = applyThemeColorToTickIcon ? '' : 'success';
  return value === 'true' ? /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    name: 'tick',
    group: "system",
    state: state,
    size: 4
  }) : /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    name: 'close',
    group: "system",
    state: "error"
  });
};
const valueTextFormatting = value => {
  return value.text ? value.text === 'true' || value.text === 'false' ? handleBooleanValue(value.text) : value.text : '-';
};
const getEntertainmentIcons = value => {
  switch (value) {
    case 'Youtube Premium':
      return /*#__PURE__*/_react.default.createElement(_brandHifiIcons.IconYoutubePremium, {
        size: 3
      });
    case 'Spotify Premium':
      return /*#__PURE__*/_react.default.createElement(_brandHifiIcons.IconSpotify, {
        size: 3
      });
    case 'Amazon Prime':
      return /*#__PURE__*/_react.default.createElement(_brandHifiIcons.IconAmazonPrime, {
        size: 3
      });
    default:
      return value;
  }
};
const renderEntertainment = value => {
  if (!value.text) return;
  const entertainmentIcons = value.text.split(',');
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(TextDataContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    align: "center"
  }, entertainmentIcons.map((iconName, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, getEntertainmentIcons(iconName), index !== entertainmentIcons.length - 1 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      right: 2,
      left: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.locale.localeString(`Specs.Or`)))))), value.duration && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 1,
    weight: 2
  }, _services.locale.localeString(`Specs.EntertainmentSubtext`), ' ' + value.duration + ' ', _services.locale.localeString(`Comparison.Months`))))));
};
const renderSpecContent = _ref => {
  let {
    label,
    value,
    productId,
    showColorToolTip = '',
    specsHeadingWeight = 3,
    applyShowDifferences = false
  } = _ref;
  const overwrittenThemeName = (0, _useConfig.default)('uiSettings.theme', '');
  switch (label) {
    case 'Colors':
      return value.colorValue && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          top: 2
        }
      }, showColorToolTip ? /*#__PURE__*/_react.default.createElement(StyledTooltip, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Tooltip, {
        id: `${productId}-${value.colorValue}`,
        appearance: "primary",
        text: value.text
      }, /*#__PURE__*/_react.default.createElement(ColorSwatchContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ColorSwatch, {
        color: value.colorValue,
        size: 4
      })))) : /*#__PURE__*/_react.default.createElement(ColorSwatchContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ColorSwatch, {
        color: value.colorValue,
        size: 4
      })));
    case 'Entertainment':
      return renderEntertainment(value);
    default:
      return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(StyledGridColumnContent, null, /*#__PURE__*/_react.default.createElement(TextDataContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
        size: 1,
        weight: value !== null && value !== void 0 && value.isLargest && applyShowDifferences ? 3 : specsHeadingWeight,
        noMargin: true,
        text: valueTextFormatting(value)
      }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
        appearance: overwrittenThemeName ? 'alt2' : 'primary'
      }, _services.locale.localeString(`Specs.${value.subText}`)))));
  }
};
//---------------------------------

//Label: Category Title
//Data: array of objects containing groups values to be displayed
exports.renderSpecContent = renderSpecContent;
const ComparisonDataDisplay = _ref2 => {
  let {
    label,
    specs,
    displayedProducts,
    applyShowDifferences,
    onNoDiff
  } = _ref2;
  const showAllProducts = displayedProducts.length >= 3;
  const currentPage = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectCurrentPage);
  const [displayedSpecs, setDisplayedSpecs] = (0, _react.useState)(specs);
  const shouldAddTableBorders = (0, _useLocalTheme.default)(`pages[${currentPage}].addTableBorders`, false);
  const specsHeadingWeight = (0, _useLocalTheme.default)(`pages[${currentPage}].specsHeadingWeight`, 3);
  const showColorToolTip = (0, _useLocalTheme.default)(`pages[${currentPage}].showColorToolTip`, false);
  const shouldDisplaySpec = value => {
    return valueTextFormatting(value) !== '-';
  };
  const SpecBoxContentData = _ref3 => {
    let {
      spec,
      productId,
      value
    } = _ref3;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(DataEntryWrapperItem, {
      group: label,
      itemLength: spec.values[productId].length
    }, /*#__PURE__*/_react.default.createElement(ExpandingWrapper, null, renderSpecContent({
      label,
      value,
      productId,
      showColorToolTip,
      specsHeadingWeight,
      applyShowDifferences
    }))));
  };
  const SpecBoxContent = _ref4 => {
    let {
      spec,
      productId,
      value
    } = _ref4;
    const gridColumnProps = label === 'Colors' && {
      col: 5,
      colMd: 4
    };
    const ColWrapper = showAllProducts ? StyledGridColumnWrapper : _r10SourceLibrary.GridColumn;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
      breakpoint: "md",
      andAbove: true
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, gridColumnProps, /*#__PURE__*/_react.default.createElement(SpecBoxContentData, {
      spec: spec,
      productId: productId,
      value: value
    }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
      breakpoint: "sm"
    }, /*#__PURE__*/_react.default.createElement(ColWrapper, gridColumnProps, /*#__PURE__*/_react.default.createElement(SpecBoxContentData, {
      spec: spec,
      productId: productId,
      value: value
    }))));
  };
  const SpecBox = _ref5 => {
    var _spec$values$productI;
    let {
      spec,
      index,
      rowPlacement,
      productId
    } = _ref5;
    const currentPage = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectCurrentPage);
    const shouldAddTableBorders = (0, _useLocalTheme.default)(`pages[${currentPage}].addTableBorders`, false);
    return /*#__PURE__*/_react.default.createElement(StyledGridColumn, {
      index: index,
      key: rowPlacement,
      col: showAllProducts ? 4 : 6,
      shouldAddTableBorders: shouldAddTableBorders
    }, /*#__PURE__*/_react.default.createElement(VerticalExpandingWrapper, null, /*#__PURE__*/_react.default.createElement(DataEntryWrapper, {
      groupLabel: label,
      "data-test-id": `features-values-${index}-${displayedProducts.indexOf(productId)}`
    }, /*#__PURE__*/_react.default.createElement(StyledSpecGridRow, {
      marginTop: 2,
      marginBottom: 2
    }, (_spec$values$productI = spec.values[productId]) === null || _spec$values$productI === void 0 ? void 0 : _spec$values$productI.map((value, valueIndex) => {
      return /*#__PURE__*/_react.default.createElement(SpecBoxContent, {
        key: valueIndex,
        spec: spec,
        productId: productId,
        value: value
      });
    })))));
  };
  const GroupSpecs = _ref6 => {
    let {
      spec,
      index
    } = _ref6;
    let shouldDisplayRow = false;
    const result = /*#__PURE__*/_react.default.createElement(StyledGridRow, {
      key: index,
      noGutters: true
    }, displayedProducts === null || displayedProducts === void 0 ? void 0 : displayedProducts.map((productId, rowPlacement) => {
      var _spec$values$productI2;
      const shouldDisplaySpecification = (_spec$values$productI2 = spec.values[productId]) === null || _spec$values$productI2 === void 0 ? void 0 : _spec$values$productI2.map(value => shouldDisplaySpec(value)).reduce((a, b) => a || b, false);
      shouldDisplayRow = shouldDisplaySpecification || shouldDisplayRow;
      return /*#__PURE__*/_react.default.createElement(SpecBox, {
        spec: spec,
        index: index,
        key: rowPlacement,
        productId: productId
      });
    }));
    return shouldDisplayRow ? result : null;
  };
  const SpecsHeader = _ref7 => {
    let {
      specs,
      label
    } = _ref7;
    const shouldDisplayHeader = displayedProducts.map(displayedProduct => specs.map(spec => spec.values[displayedProduct])).flat(2).filter(specValue => specValue === null || specValue === void 0 ? void 0 : specValue.text).length;
    return !!shouldDisplayHeader && /*#__PURE__*/_react.default.createElement(LightContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 3,
        bottom: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 1,
      weight: 3,
      text: `${_services.locale.localeString(`SpecsGroup.${label}`)}`,
      dataAttributes: {
        'data-test-id': 'feautres-title'
      }
    })));
  };
  const handleLargestNumericValues = (numericValue, label) => {
    var _numericValue, _numericValue2;
    if (label === 'memory') {
      const sizesInBytes = numericValue.split(',').flat(2).map(_utils.convertToBytes);
      const maxBytes = Math.max(...sizesInBytes);
      // Convert the maximum value back to the original unit
      const maxValue = (0, _utils.convertBytesToMaxUnits)(maxBytes);
      return maxValue;
    }
    if ((_numericValue = numericValue) !== null && _numericValue !== void 0 && _numericValue.includes('x')) {
      numericValue = Math.max(...numericValue.split('x').map(number => parseFloat(number)));
    }
    if (numericValue === '') return 0;
    // handle case when value contains strings and numbers
    numericValue = isNaN(numericValue) && (_numericValue2 = numericValue) !== null && _numericValue2 !== void 0 && _numericValue2.match(/\d+(\.\d+)?/g) ? numericValue.match(/\d+(\.\d+)?/g)[0] : numericValue;
    return numericValue;
  };
  const checkDuplicateInArray = (value, array) => {
    const values = array.filter(val => val === null || val === void 0 ? void 0 : val.includes(value));
    return values.length > 1;
  };
  const handleLargestSpecValues = (spec, allValues) => {
    let largestNumericValue;
    if ((spec === null || spec === void 0 ? void 0 : spec.label) === 'memory') {
      // get largest memory in each spec. largestNumericValue will be array contains largest number of all specs
      largestNumericValue = allValues.map(x => {
        let numericValue = x;
        numericValue = handleLargestNumericValues(numericValue, spec.label);
        return numericValue;
      });
      const sizesInBytes = largestNumericValue.map(_utils.convertToBytes);
      // get largest memory in all specs
      const maxBytes = Math.max(...sizesInBytes);
      const maxValueWithOriginalUnit = (0, _utils.convertBytesToMaxUnits)(maxBytes);
      largestNumericValue = maxValueWithOriginalUnit;
    } else {
      largestNumericValue = Math.max(...allValues.map(x => {
        let numericValue = x;
        numericValue = handleLargestNumericValues(numericValue, spec.label);
        return parseFloat(numericValue);
      }));
    }
    const ignoredLabels = ['Operating System', 'Sim Type'];
    // map on all specs values and add isLargest = true to the largest value.
    const specValues = {
      ...spec
    };
    displayedProducts.map(productId => {
      specValues.values[productId].map(value => {
        let numericValue = value === null || value === void 0 ? void 0 : value.text;
        numericValue = handleLargestNumericValues(numericValue, spec.label);
        if (parseFloat(numericValue) === parseFloat(largestNumericValue) && !checkDuplicateInArray(largestNumericValue, allValues) && !ignoredLabels.includes(spec.label)) {
          value.isLargest = true;
        }
        return value;
      });
    });
    return specValues;
  };
  const handleShowDifferencesDisplay = specs => {
    const diffSpecs = [];
    // get all values of specs for all product ex: get all memories of all products
    specs.filter(spec => spec.label !== 'color').map(spec => {
      const allValues = [];
      displayedProducts.map(productId => {
        const specValues = spec.values[productId].map(value => value.text);
        allValues.push(...specValues);
      });

      // check if all values are different
      if (!allValues.every(val => val == allValues[0])) {
        const finalSpec = handleLargestSpecValues(spec, allValues);
        diffSpecs.push(finalSpec);
      }
    });
    return diffSpecs;
  };
  (0, _react.useEffect)(() => {
    setDisplayedSpecs(applyShowDifferences ? handleShowDifferencesDisplay(specs) : [...specs]);
  }, [applyShowDifferences, specs]);
  (0, _react.useEffect)(() => {
    if (!displayedSpecs.length) onNoDiff(true);else onNoDiff(false);
  }, [displayedSpecs]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "GroupSpecsContainer"
  }, /*#__PURE__*/_react.default.createElement(SpecsHeader, {
    specs: displayedSpecs,
    label: label
  }), shouldAddTableBorders ? /*#__PURE__*/_react.default.createElement(GroupSpecsWrapper, {
    removeBorder: !(displayedSpecs !== null && displayedSpecs !== void 0 && displayedSpecs.length)
  }, displayedSpecs === null || displayedSpecs === void 0 ? void 0 : displayedSpecs.map((spec, index) => /*#__PURE__*/_react.default.createElement(GroupSpecs, {
    spec: spec,
    key: index,
    index: index
  }))) : /*#__PURE__*/_react.default.createElement("div", null, displayedSpecs === null || displayedSpecs === void 0 ? void 0 : displayedSpecs.map((spec, index) => /*#__PURE__*/_react.default.createElement(GroupSpecs, {
    spec: spec,
    key: index,
    index: index
  }))));
};
var _default = ComparisonDataDisplay;
exports.default = _default;